import { useContext } from 'react'
import GlobalContext, { SettingsDto } from '../context/GlobalContext'

export function useSettings(): SettingsDto {
    const { settings } = useContext(GlobalContext)
    return settings
}
